import React from 'react';
import PropTypes from 'prop-types';

// Container for the Google Places autocomplete control. The PlaceAutocompleteElement web component
// (Places API New) is created in MapUtils.setUpSearchControl, appended here, and then the whole
// wrapper is pushed into the map's control layer. This component only owns the wrapper's visibility
// (hidden once an area is defined) and styling — the element renders its own input.
function MapSearchBox(props) {
  const { id, show } = props;

  return (
    <div
      id={`${id}-map-search-input-wrapper`}
      className='o-map__search'
      style={{ display: `${show ? 'flex' : 'none'}` }}
    />
  );
}

MapSearchBox.propTypes = {
  id: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
};

export default MapSearchBox;
